export default {
    waitingArea:'Waiting area',
    guidedLanding:'Guided landing',
    landHeight:'Waiting height',
    conversionHeight:'Conversion height',
    flySpeed:'Flight speed',
    entryDirection:'Approach direction',
    landingPosition:'Landing point location',
    mapPosition:'Map selection',
    uavPosition:'Drone current location',
    landingParameters:'Landing parameters',
    landingPointAltitude:'Landing point altitude',
    recyclingLandingParameters:'Dynamic recovery landing parameters',
    waitingAreaRadius:'Waiting area radius',
    waitingAreaHeight:'Relative height of landing area',
    waitingAreaDistance:'Distance from the landing area to the landing point',
    guidanceSpeed:'Guide segment speed',
    goAroundHeight:'Go-around climb altitude',
    recyclingExpandParameters:'Dynamic Recycling Extension Parameters',
    conversionPointHeight:'Transition point height',
    otherModels: 'Other models',
    HUTF: 'VTL',
    upgrading: 'Upgrading',
    //header部分
    set: 'Ground Station Setting',
    logout: 'Logout',
    noSignal: 'No Signal',
    setting: 'Setting',
    news: 'News',
    user: 'User',
    em: 'Equipment Management',
    dataLink: 'Data link',
    connected: 'Connected',
    notConnected: 'Not connected',
    strongSignal: 'Strong signal',
    weakSignal: 'Weak signal',
    windSpeed: 'Wind speed',
    windDirection: 'Wind direction',
    temperature: 'Temperature',
    humidity: 'Humidity',
    airPressure: 'Air pressure',
    weatherStation: 'Weather station',
    urgent: 'Urgent',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    usedFlow: 'Used flow',
    residualFlow: 'Residual flow',
    page: '{index}D Page',
    //辅助信息部分
    errMsg: 'Err MSG',
    moreTools: 'More Tools',
    flightMode: 'Flight Mode',
    targetPoint: 'Target Point',
    distance: 'Distance',
    currentPOS: 'Current POS：',
    fail: 'Getting information failure',
    normal: 'Ready to flight',
    debugging: 'Test Assistant',
    flightLog: 'Flight log',
    sensor: 'Sensor calibration',
    journal: 'Flight Log',
    devTools: 'Developer Tools',
    flightTime: 'Flight Time',
    flightDistance: 'Flight Distance',
    generalConfig: 'General Config',
    RTKSettings: 'RTK Settings',
    AC: 'Accelerometer Calibration',
    CC: 'Compass Calibration',
    RC: 'Rocker Calibration',
    LC: 'Level Calibration',
    VC: 'Vertical Calibration',
    MT: 'Motor Test',
    getList: 'Get list',
    snatchSession: 'Snatch session',
    downloadMachine: 'Download this machine',
    cancelDownload: 'Cancel download',
    downloadAgain: 'Download again',
    size: 'Size',
    batteryInformation: 'Battery Info',
    batteryType: 'Battery Type',
    electricity: 'Electricity',
    voltage: 'Voltage',
    current: 'Current',
    notAcquired: 'Not Acquired',
    productionDate: 'Production Date',
    parachuteSelfCheckStatus: 'Parachute self check status',
    parachuteOpeningStatus: 'Parachute opening status',
    selfCheckPassed: 'Self check passed',
    selfTestFailed: 'Self test failed',
    locked: 'Locked',
    unlocked: 'Unlocked',
    umbrellaOpened: 'Umbrella opened',
    // speed:'Speed',
    enter: 'Enter',
    download: 'Download',
    //工具栏
    uavList: 'UAV List',
    map: 'Map',
    video: 'Video',
    taskManagement: 'Task Management',
    fastTask: 'Fast Task',
    quickPuzzle: 'Quick Puzzle',
    achievementDisplay: 'Achievement Display',
    tagManagement: 'Tag Management',
    electronicFence: 'Electronic Fence',
    CT: 'Coordinate Transformation',
    degrees: 'Degrees',
    DMS: 'DMS',
    measuring: 'Measuring',
    waypointEditor: 'Waypoint Editor',
    routeEditor: 'Route Editor',
    routeTemplate: 'Route Template',
    arbitraryFlight: 'Arbitrary Flight',
    clearTrajectory: 'Clear Trajectory',
    DOH: 'Double optical head',
    megaphone: 'Megaphone',
    LS: 'Load Setting',
    VFS: 'Full Screen',
    pictureLayout: 'Picture Layout',
    PTZSetting: 'PTZ Setting',
    clearMeasurementLayer: 'Clear Measurement Layer',
    formationFlying: 'Formation Flying',
    robotDog: 'Robot Dog',
    //航点编辑
    reverse: 'Reverse',
    cycles: 'Cycles',
    height: 'H',
    speed: 'V',
    waypointMode: 'WP AC',
    turnMode: 'Turn Mode',
    radius: 'Radius',
    altitude: 'Altitude',
    time: 'Time',
    editWP: 'Edit WP',
    editPosition: 'Edit Position',
    azimuth: 'Azimuth',
    editDirection: 'Edit Direction',
    complete: 'Complete',
    added: 'Added',
    insert: 'Insert',
    save: 'Save to route list',
    openRouteList: 'Open route list',
    open: 'Open',
    del: 'Delete',
    revoke: 'Revoke',
    redo: 'Redo',
    home: 'Home',
    editHome: 'Edit Home',
    editComplete: 'Complete',
    goHome: 'Go Home',
    noHome: 'Home point not planned',
    circlingDirection: 'Circling direction',
    clockwise: 'Clockwise',
    counterclockwise: 'Counterclockwise',
    liftMode: 'Lift mode',
    liftImmediately: 'Lift immediately',
    highProtection: 'High protection',
    circlingRadius: 'Circling radius',
    readHoming: 'Read homing',
    nosePointing: 'Nose Pointing',
    followTheRoute: 'Follow the route',
    target: 'Target',
    courseModification: 'Course Modification',
    device: 'Device',
    action: 'Action',
    serialNumber: 'Serial Number',
    routeClosed: 'Route Closed',
    export: 'Export {0}',
    import: 'Import {0}',
    position: 'Position',
    upload: 'Upload',
    imageSwitching: 'Image Switching',
    rowsColumns: 'Detected：{rows} rows,{cols} columns',
    latLngStart: 'latitude and longitude start line',
    column: 'column of {0}',
    whichColumn: 'Column {0}',
    LPRM: 'License Plate Recognition Mode',
    batchEdit: 'Batch Edit',
    //航线编辑
    routeNumber: 'Route Number',
    routeHeight: 'Height',
    routeSpeed: 'Velocity',
    remainingTimes: 'Remaining Times',
    routeEndAction: 'End AC',
    routeEntryPoint: 'Entry Point',
    routeLength: 'Route Length',
    estimatedFlightTime: 'Estimated Flight time',
    rotation: 'Spin',
    translation: 'Moving',
    //航线模板
    triangle: 'Triangle',
    rectangle: 'Rectangle',
    polygone: 'Polygone',
    round: 'Round',
    scan: 'Scan',
    sideLength: 'Side Length',
    RH: 'R-H',
    startToEnd: 'Start to End',
    length: 'Length',
    width: 'Width',
    number: 'Number',
    addArea: 'Add Area',
    scanAngle: 'Scan Angle',
    scanInterval: 'Scan Interval',
    scanArea: 'Scan Area',
    Import: 'Import WP Editor',
    inSurvey: 'During measurement, please finish the measurement first',
    scanIntervalFormat: 'Minimum scan interval is 1',
    STA: 'Scan the area',
    repaint: 'Repaint',
    photoShootingMethod: 'Photo shooting method',
    photoInterval: 'Photo Interval',
    //指点飞行
    hoverTime: 'Hover Time',
    timeoutAC: 'Timeout AC',
    enterPointingFlightMode: 'Enter Arbitrary Flight',
    exitAdvice: 'Exit Arbitrary Flight',
    startExecution: 'Execute',
    noPointing: 'Please plan the flight position first',
    pointingFlight: 'Pointing flight',
    isPointingFlight: 'Start arbitrary flight?',
    IAL: '0 is always loop',
    pointingDistance: 'Pointing distance',
    returnFlight: 'Return Flight',
    landing: 'Landing',
    //航线列表
    routeList: 'Route List',
    routeName: 'Route Name',
    search: 'Search',
    createTime: 'Create Time',
    operation: 'Operation',
    use: 'Use',
    noUaerid: 'User ID is empty',
    share: 'Share',
    merge: 'Merge',
    dragSort: 'Drag sort',
    routeRemarks: 'Route remarks',
    relativeAltitudeRoute: 'Relative altitude route',
    altitudeRoute: 'Altitude route',
    PETN: '0~100 characters in length',
    //操作按钮
    endPperation: 'End of flight test',
    takeoverControl: 'Recovery control',
    releaseControl: 'Release control',
    uavLocation: 'Positioning',
    executionRoute: 'Execution Route',
    takeOff: 'Take off',
    flightSuspension: 'FLT Suspension',
    flightContinue: 'FLT Continue',
    land: 'Land',
    directReturn: 'Direct Return',
    trackReturn: 'Track Return',
    manual: 'Manual',
    emergencyStop: 'E-Stop',
    loadControl: 'Load Control',
    SC: 'Speed control',
    HC: 'Height control',
    NOU: 'UAV number',
    DP: 'Default pointcut',
    CSQ: 'Currently selected quantity',
    TOS: 'Order',
    meanwhile: 'Meanwhile',
    delayed: 'Delayed',
    delayedTakeoff: 'Delayed takeoff',
    emergency: 'Emergency',
    RTF: 'Ready to fly',
    unlock: 'Unlock',
    takeoff: 'Take off',
    route: 'Route',
    waypoint: 'Waypoint',
    cycle: 'Cycle',
    unlimited: 'Unlimited',
    EATN: 'Enter after the end',
    homingHovering: 'Homing hovering',
    homingLanding: 'Homing Landing',
    CLR: 'Change landing route',
    executeImmediately: 'Execute immediately',
    returnHome: 'Return home',
    flightControl: 'Flight control',
    standardLanding: 'Standard landing',
    MRL: 'Multi-rotor landing',
    MRQRL: 'Multi-rotor return and landing',
    FWA: 'Fixed-wing alternate',
    sprayOn: 'Spray on',
    sprayOff: 'Spray off',
    moreInstructions: 'More instructions',
    spraySetting: 'Spray setting',
    typesOf: 'Types of',
    WPL: 'Water pump-left',
    WPR: 'Water pump-right',
    WPF: 'Water pump full',
    NV: 'Numerical value',
    actionOn: 'Action On',
    actionOff: 'Action Off',
    startPuzzle: 'Start Puzzle',
    endPuzzle: 'End Puzzle',
    aisle: 'Aisle',
    left: 'Left',
    right: 'Right',
    proportion: 'Proportion',
    return: 'Return',
    airlineFlight: 'Airline Flight',
    routePerformed: 'Route to be performed',
    entryPoint: 'Entry Point',
    waitExecutionTime: 'Wait Execution Time',
    entryPointError: 'Entry point error',
    intervalSendTime: 'Interval send time',
    deviceFunction: 'Device function',
    configure: 'Configure',
    without: 'Without',
    gimbalDown: 'PTZ Down',
    gimbalReset: 'PTZ Reset',
    followMode: 'Follow Mode',
    courseLock: 'Course Lock',
    freeMode: 'Free Mode',
    MRLIP: 'Multi-rotor landing in place',
    MRFRL: 'Multi-rotor return and landing',
    rotorAlternate: 'Rotor Alternate',
    fixedWingAlternate: 'fixed wing alternate',
    startFromThePointcut: 'Start from the pointcut',
    startFromTheStartingPoint: 'Start from the starting point',
    executionOrder: 'Execution order',
    heightAdjustment: 'Height Adjustment',
    speedAdjustment: 'Speed Adjustment',
    reset: 'Reset',
    oneKeyDown: 'One key down',
    followTheAircraftHead: 'Follow the aircraft head',
    // 通用配置
    ATOWR: 'Allow take off without RTK',
    CM: 'Climb Mode',
    tilt: 'Tilt',
    vertical: 'Vertical',
    cycleMode: 'Cycle Mode',
    BP: 'Breakthrough Point',
    SP: 'Starting Point',
    RA: 'Return Altitude',
    HL: 'Height Limit',
    RS: 'Return Speed',
    returnHomingDirection: 'Return/Homing direction',
    headOrientation: 'Head orientation',
    tailOrientation: 'Tail orientation',
    securitySetting: 'Security Setting',
    TOWPIA: 'Take off without parachute is allowed',
    AWAF: 'After waypoint action fails',
    continueTheRoute: 'Continue the route',
    waitFor: 'Wait For',
    RCOOCP: 'Remote control out of control protection',
    linkRunawayProtection: 'Link runaway protection',
    NA: 'No Action',
    hover: 'Hover',
    returnH: 'Return',
    EA: 'Electricity Alarm',
    FLA: 'First level alarm',
    EQ: 'Electricity Quantity',
    PS: 'Protection Strategy',
    SALA: 'Sound and light alarm',
    SA: 'Secondary alarm',
    aileron: 'Aileron',
    lift: 'Lift',
    accelerator: 'Accelerator',
    direction: 'Direction',
    airplaneMode: 'Airplane Mode',
    output: 'Output',
    test: 'Test',
    channelTest: 'Channel Test',
    singleShot: 'Single Shot',
    continuousShooting: 'Continuous Shooting',
    oneShot: 'One Shot',
    burstStarts: 'Burst Starts',
    burstEnds: 'Burst Ends',
    pitch: 'Pitch',
    roll: 'Roll',
    yaw: 'Yaw',
    flowRate: 'Flow Rate',
    minimum: 'Minimum',
    maximum: 'Maximum',
    automatic: 'Automatic',
    close: 'Close',
    currentChannel: 'Current Channel',
    trigger: 'Trigger',
    flightParameters: 'Flight Parameters',
    heightLimit: 'Remote control height limit',
    flightSpeed: 'Flight speed of remote controller',
    outputChannelBinding: 'Output Channel Binding',
    inputChannelMapping: 'Input Channel Mapping',
    protectiveFunction: 'Protective Function',
    flightInspection: 'Flight Inspection',
    sensorStatus: 'Sensor status',
    thrustTest: 'Thrust Test',
    turnOffImmediately: 'Turn Off Immediately',
    abortAction: 'Abort Action',
    rotorReadyToTakeOff: 'Rotor ready to take off',
    rotorAttitudeThrottle: 'Rotor Attitude Throttle',
    rotorPositioningRemoteControl: 'Rotor positioning remote control',
    FWRS: 'Fixed wing rudder surface remote control',
    FWAR: 'Fixed wing attitude remote control',
    joystickStatus: 'Joystick Status',
    magneticCompass: 'Magnetic Compass',
    japaneseHand: 'Japanese Hand',
    americanHand: 'American Hand',
    chineseHand: 'Chinese Hand',
    antiJapaneseHand: 'Anti Japanese Hand',
    dataLinkConnection: 'Data Link Connection',
    internalGNSSSystem: 'Internal GNSS system',
    rockerConnection: 'Rocker Connection',
    externalGNSSSystem: 'External GNSS system',
    flightControlMode: 'Flight Control Mode',
    navigationState: 'Navigation State',
    fixedWingThrottle: 'Fixed Wing Throttle',
    rotorThrottle: 'Rotor Throttle',
    ATP: 'Automatic takeoff parameters',
    presetClimbAltitude: 'Preset climb altitude',
    fixedWing: 'FW',
    multiRotor: 'MC',
    timeProtection: 'Time Protection',
    protectionMethod: 'Protection Method',
    notProtected: 'Not Protected',
    protectionTime: 'Protection Time',
    // 云台
    SR1: 'Start Recording',
    SR2: 'Stop Recording',
    photograph: 'Photograph',
    zoom: 'Zoom',
    IAOR: 'Inner angle of route',
    targetLock: 'Target Lock',
    targetUnlock: 'Target Unlock',
    infraredSwitching: 'Infrared Switching',
    recordingNotTurnedOn: 'Recording not turned on',
    solveTargetPosition: 'Solve the target position',
    startTargetRecognition: 'Start target recognition',
    stopTargetRecognition: 'Stop target recognition',
    targetRecognitionStatistics: 'Target recognition statistics',
    videoFrameSelection: 'Video frame selection',
    confirmTracking: 'Confirm tracking',
    licensePlateRecognition: 'License Plate Recognition',
    getFlightControl: 'Get flight control',
    // 车牌识别
    pictureList: 'Picture List',
    shootingDate: 'Shooting Date',
    unrecognized: 'Unrecognized',
    sameDay: 'Same Day',
    twoDays: 'Two Days',
    threeDays: 'Three Days',
    aWeek: 'A Week',
    // 喊话器
    startRecording: 'Start recording',
    playRecording: 'Play recording',
    volume: 'Volume',
    // 画面设置
    resolutionSetting: 'Image settings',
    videoStreaming: 'Video streaming',
    format: 'Format',
    resolution: 'Resolution',
    codeRate: 'Code rate',
    // 高程信息
    elevationInformation: 'Elevation information',
    numbering: 'Numbering',
    details: 'Details',
    // 电子围栏
    model: 'Model',
    polygonElectricFence: 'Polygon Electric Fence',
    startPicking: 'Start Picking',
    endPicking: 'End Picking',
    clearPicking: 'Clear Picking',
    read: 'Read',
    // 载荷
    megaphoneLoad: 'Megaphone Load',
    play: 'Play',
    selectFile: 'Select File',
    siren: 'Siren',
    textPlay: 'Text Play',
    // 任务成果
    taskOutcome: 'Mission Outcome',
    taskName: 'Mission Name',
    aerialSurveyMission: 'Aerial Survey Mission',
    taskType: 'Task Type',
    startAndEndTime: 'Start and end time',
    start: 'Start',
    end: 'End',
    address: 'Address',
    generateTarget: 'Generate Target',
    // 生命探测记录
    lifeDetection: 'Life Detection',
    uavName: 'UAV Name',
    flightAltitude: 'Flight Altitude',
    signalDistance: 'Signal Distance',
    confirm: 'Confirm',
    suspected: 'Suspected',
    collectionTime: 'Collection Time',
    positionCoordinates: 'Position Coordinates',
    signalStrength: 'Signal Strength',
    strongest: 'Strongest',
    realTime: 'Real Time',
    startDetection: 'Start Detection',
    endDetection: 'End Detection',
    // 编队飞行
    formationMainRouteEdit: 'Formation main routeEdit',
    totalNumberFormations: 'Total number of racks',
    executeNextRoute: 'Execute Next Route',
    delayActionTime: 'Delay Action Time',
    formationEditor: 'Formation Editor',
    saveFormationFile: 'Save Formation File',
    formationFileList: 'Formation File List',
    uploadFormationRoute: 'Upload Formation Route',
    uavNumber: 'UAV Number',
    formationFileName: 'Formation File Name',
    editName: 'Edit Name',
    editFile: 'Edit File',
    cellDistance: 'Cell Distance',
    offsetDirectionAngle: 'Offset Direction Angle',
    axisOffset: '{name}-axis offset (meter)',
    formation: '{msg} Formation',
    topView: 'Top View',
    rightView: 'Right View',
    frontView: 'Front View',
    // RTK设置
    rtkFrontView: 'RTK current status',
    normalOK: 'Normal',
    noService: 'No Service',
    dataForwardingType: 'Data Forwarding Type',
    BAUOBS: 'Binding and unbinding of base stations',
    encryptionMode: 'Encryption Mode',
    publicMode: 'Public mode (no password)',
    linkingPassword: 'Linking Password',
    ntripHostAddress: 'NtripHost Address',
    port: 'Port',
    username: 'Username',
    password: 'Password',
    mountPoint: 'Mount Point',
    notUsingRTK: 'Not Using RTK',
    confirmAdjustment: 'Confirm Adjustment',
    standardNetwork: 'Standard Network',
    otherNetwork: 'Other Network',
    localNetwork: 'Local Network',
    customNetwork: 'Custom Network',
    doNotUse: 'Do Not Use',
    allocationConfirmation: 'Allocation Confirmation',
    allocationSuccessful: 'Allocation Successful',
    allocationFailed: 'Allocation Failed',
    aiRecognitionStatistics: 'AI recognition statistics',
    pedestrian: 'Pedestrian',
    vehicle: 'Vehicle',
    imageZoom: 'Image Zoom',
    imageReduction: 'Image Reduction',
    // 提示
    tips_routerSportNumber: 'Please plan at least two waypoints',
    tips_MD: 'Measurement layer deleted successfully',
    tips_MStart: 'Measurement start',
    tips_MEnd: 'Measurement end',
    tips_noSelectUAV: 'UAV is not selected, do you want to switch to offline mode?',
    tips_noSelectRS: 'Please select a waypoint',
    tips_SelectRS: 'Please select at least one waypoint',
    tips_errA: 'There is a class {err} fault in {uav}, please deal with it as soon as possible',
    tips_inputError: '{name} input error',
    tips_HInputError: 'Height input error',
    tips_SInputError: 'Velocity input error',
    tips_SO: 'Successful operation',
    tips_AF: 'Add finish',
    tips_isD: 'Are you sure you want to delete?',
    tips_loopErr: 'Wrong number of cycles!',
    tips_Upload: 'Uploaded to server!',
    tips_RName: '1~20 characters in length',
    tips_noRoute: 'Please plan the route first',
    tips_ALT: 'Please plan at least two waypoints',
    tips_IEP: 'Incorrect entry point',
    tips_PEP: 'Please enter a pointcut',
    tips_endspot: 'The last waypoint can only be Land, Return to Starting or Return to Home',
    tips_planFailure: 'Wrong waypoint planning',
    tips_crosNoFly: "The route can't cross the no fly zone, please re plan",
    tips_RTRF: 'Route through restricted flight zone(altitude <= 300m), please re plan',
    tips_IIPT: 'It is possible to cross the no fly zone during flight. Please re plan',
    tips_homingNoFly: 'The return point cannot be in the no fly zone, please re plan',
    tips_HPEF: 'The return point must be in the electronic fence, please re plan',
    tips_PFNoFly: 'Pointing flight is not allowed in the no fly zone, please re plan',
    tips_PFEF: 'Pointing flight must be in the electronic fence, please plan again',
    tips_EFNoFly: 'The route must be in the electronic fence, please re plan',
    tips_enterAreaMeas: 'Please enter an area measurement layer description',
    tips_takeOver: 'The owner has regained control',
    tips_endTakeOver: 'Your test flight is over. Do you want to exit?',
    dist: 'Dist',
    relativeDist: 'Relative Dist',
    angle: 'Angle',
    relativeAngle: 'Relative Angle',
    tip_AETMCA: 'Altitude exceeds the maximum cruise altitude',
    tip_TRETMSR: 'The radius exceeds the maximum safe radius',
    // 校准提示
    tip_CC: 'Calibration completed',
    tip_ESCTC: 'Enter Sn code to confirm',
    tip_ICAYSTC: 'In calibration, are you sure to cancel?',
    tip_UIFPTAL: 'UAV in flight, please try again later',
    tip_KAFEIAC: 'Keep away from electromagnetic interference after calibration',
    tip_DNMTAACB: 'Do not move the aircraft after calibration begins',
    tip_BSTRAPFT: 'Be sure to remove all propellers for testing',
    tip_PKTPLITFD: 'Please keep the plane level in the forward direction',
    tip_PKTNDAV: 'Please keep the nose down and vertical',
    tip_PKTNU: 'Please keep the nose upright',
    tip_PKTLSOTAFDV: 'Please keep the left side of the aircraft facing down vertically',
    tip_PKTRSOTAFDV: 'Please keep the right side of the aircraft facing down vertically',
    tip_PKTPIRAHP: 'Please keep the plane in reverse and horizontal position',
    tip_PKTPLARAA: 'Please rotate the drone 3 times at a constant speed, then flip it 180 degrees horizontally to an inverted state, and rotate it 3 times at a constant speed again.',
    tip_PKTLSOTPFDARAACS: 'Please keep the left side of the plane face down and rotate at a constant speed',
    tip_PKTANUARAACS: 'Please keep the aircraft nose up and rotate at a constant speed',
    tip_PKARCP: 'Please keep all remote control poles neutral and click to start remote control calibration',
    tip_PTTRET: 'Please turn the rocker evenly to contact the limit position',
    tip_PKAPN: 'Please keep all poles neutral',
    tip_PKTNS: 'Please keep the nose still upward, and the horizontal angle is greater than 70 degrees',
    tip_VL: 'Video Loading',
    // 通用配置提示
    tip_RACBE: 'Return altitude cannot be empty',
    tip_PEANV: 'Please enter an integer',
    tip_RAMBG: 'Return altitude must be greater than or equal to 5',
    tip_TRAMB: 'The return altitude must be less than the altitude limit',
    tip_HLCBE: 'Height limit cannot be empty',
    tip_HLR: 'Height limit range 3 ~ 500',
    tip_RSCBE: 'Return speed cannot be empty',
    tip_RSR: 'Return speed range 2 ~ 10',
    tip_SDT: 'Simulate drone timeout',
    tip_LAL: 'Longitude and latitude input error, please re-enter',
    tip_enterHeading: 'Please enter heading angle',
    tip_addTargetPoint: 'Please add a target point',
    tip_WACO: 'Waypoint actions can only modify one waypoint at a time',
    tip_selectDev: 'Please select a device',
    tip_selectAction: 'Please select an action',
    tip_enterInte: 'Please enter an integer',
    tip_TSVO: 'The minimum value of the action parameter is',
    tip_TMVOT: 'The maximum value of action parameters is',
    tip_enterAction: 'Please enter action parameters',
    tip_TIAB: 'There is a breakpoint on the current route, do you want to fly from the breakpoint?',
    tip_TDWA: 'The drone will automatically take off and hover, please enter the hovering height (1~200 integer)',
    tip_HHIE: 'Hover height input error',
    tip_enterImgSwitching: 'Please enter the PWM value for image switching',
    tip_enterSinglePhoto: 'Please enter the PWM value for a single photo',
    tip_enterStartCS: 'Please enter the PWM value to start continuous shooting',
    tip_enterEndCS: 'Please enter the PWM value for the end of continuous shooting',
    tip_TPVF: 'The PWM values for the start and end of the continuous shooting cannot be equal',
    tip_enterAngle: 'Please enter an angle value',
    tip_enterPWM: 'Please enter PWM value',
    tip_PWMVCBE: 'PWM values cannot be equal',
    tip_PWMCBE: 'PWM cannot be empty',
    tip_FRCB: 'Flow rate cannot be empty',
    tip_TMVO: 'The minimum value of PWM is less than the maximum value',
    tip_TMVOF: 'The minimum value of the flow rate is less than the maximum value',
    tip_enterPWMoff: 'Please enter the PWM value for off',
    tip_enterPWMon: 'Please enter the open PWM value',
    tip_OAOP: 'OFF and ON PWM values cannot be equal',
    tip_EPSR: 'Please enter the PWM value to start recording',
    tip_EPER: 'Please enter the PWM value to end the recording',
    tip_TPVOS: 'The PWM values of start recording and end recording cannot be equal',
    tip_APEF: 'A polygonal electronic fence requires at least three points',
    tip_TSAR: 'The scanning angle range is -360~360',
    tip_ANWS: 'A number with side length greater than 0',
    tip_LIAN: 'Length is a number greater than 0',
    tip_WIAN: 'Width is a number greater than 0',
    tip_ANWA: 'A number with a radius greater than 0',
    tip_PITV: 'Please input the value',
    tip_TIDTD: 'There is data that does not conform to the format in the route editor',
    tip_TIMTO: 'There is more than one drone list currently checked, and the entry point cannot be set. The default is 1.',
    tip_fileError: 'File error, please check whether the content of the file is correct',
    tip_pleaseEnterKeyword: 'Please enter a keyword',
    tip_REAEM: 'Route Editor: Altitude exceeds maximum cruise altitude',
    tip_REREM: 'Route Editor: Radius exceeds maximum safe radius',
    tip_TWTOUA: 'The waiting time of UAV after receiving the command',
    tip_ISTOCC: 'Interval sending time of control command',
    tip_YCDTLY: 'You can drag the list up and down to sort the execution order of UAVs',
    tip_PSTRTB: 'Please select the route to be executed',
    tip_PMST: 'Please make sure the life detection device is connected to the drone!',
    tip_TDPT: 'The detection process takes 5-10 minutes each time, please pay attention to the detection data!',
    tip_TNOA: 'The number of aircraft in the formation is 0, please enter the number of aircraft in the formation!',
    tip_TMRI: 'The main route is empty, please plan the main route!',
    tip_PETF: 'Please enter the formation file name',
    tip_EBSN: 'Enter base station number to search',
    tip_TPBS: 'Third-party base stations need to contact the administrator to activate or deactivate them.',
    tip_TRSH: 'The RTK service has been assigned to the drone (SN: {id1}). Whether to adjust it to the current drone (SN: {id2}), the original drone will no longer receive network RTK differential data after confirmation.',
    tip_ANRA: 'Another network RTK account (service number: {rtkKey}) has been assigned to the current aircraft, and differential data can be obtained normally.',
    tip_TRSI: 'The RTK service is not activated and differential data cannot be obtained.',
    tip_TRSHE: 'The RTK service has expired and differential data cannot be obtained.',
    tip_FEPE: 'Format error, please enter an integer from 1-65535!',
    tip_PCALP: 'Please select a landing point',
    tips_THPMB: 'The homing point must be within the electronic fence, please re-plan',
    tips_PETT: 'Please enter the target ID',
    tips_ITCR: 'Is the current route covered?',
    tips_DTCP: 'Drag to change position.',
    tips_HDTA: 'Hold down the Alt key and drag up and down to change the height.',
    tips_ASPT: 'After selecting, press the Delete key to delete.',
    tips_TDCB: 'The drone cannot be repeated, please select again!',
    tips_TVSC: 'The video source cannot be repeated, please select again!',
    tips_WAHA: 'Waypoint {number} already has a time-lapse photo action. Please do not add it again.',
    tips_WAHAE: 'Waypoint {number} already has an equidistant photo action, please do not add it again.',
    tips_PETP: 'Please enter the PWM value for image amplification',
    tips_PETPR: 'Please enter the PWM value for image reduction',
    tips_TPVF: 'The PWM values ​​for image enlargement and image reduction cannot be equal',
}